export default "__VITE_ASSET__CdPOlOtP__"